export default function TrustBar() {
  const items = ['10 Years in Business', '20,000+ Landlords Served', 'Fully Insured', '7 Days a Week'];
  return (
    <div className="bg-navy text-white py-5">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 flex flex-wrap justify-center items-center gap-x-0 gap-y-2">
        {items.map((item, i) => (
          <span key={item} className="flex items-center">
            {i > 0 && <span className="hidden md:block w-px h-3 bg-white/20 mx-6" />}
            <span className="caps-label text-white/80">{item}</span>
          </span>
        ))}
      </div>
    </div>
  );
}